import { render, staticRenderFns } from "./grading-score-entry.vue?vue&type=template&id=80188cb0&scoped=true&"
import script from "./grading-score-entry.vue?vue&type=script&lang=js&"
export * from "./grading-score-entry.vue?vue&type=script&lang=js&"
import style0 from "./grading-score-entry.vue?vue&type=style&index=0&id=80188cb0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80188cb0",
  null
  
)

export default component.exports